import * as React from 'react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { LinkLayout } from '../../../../../../Shared/Frontend/utils/links'
import type { LinkListBlockNested } from '../../modernBlocks.state'
import { LinkListBlockLayout } from '../linkListBlock/linkListBlock.layout'

export type LinkListBlockNestedClassNames = Partial<{
  block: string
  inview: string
  inner: string
  list: string
  item: string
  itemClickable: string
}>

export const linkListBlockNestedClasses: LinkListBlockNestedClassNames = {
  block: 'block--nested block--text-nested',
  inner: 'block__inner',
  list: 'list',
  item: 'list__item',
  itemClickable: 'list__link',
}

export const LinkListBlockNestedLayout = (props: LinkListBlockNested) => {
  const { items, index } = props
  return (
    <div key={index} className={getClassNameModern(linkListBlockNestedClasses, 'block', '')}>
      <div className={getClassNameModern(linkListBlockNestedClasses, 'inner', 'pt-3')}>
        <ul className={getClassNameModern(linkListBlockNestedClasses, 'list', 'pt-3')}>
          {items.map((item, key) => (
            <li
              key={`nested-linklist-${key}`}
              className={getClassNameModern(linkListBlockNestedClasses, 'item', 'list-group-item')}
            >
              <LinkLayout
                link={item.link}
                className={getClassNameModern(
                  linkListBlockNestedClasses,
                  'itemClickable',
                  'd-flex align-items-baseline py-2 text-decoration-none'
                )}
              >
                <LinkListBlockLayout.ItemInner itemLink={item.link} subTitle={item.subTitle} />
              </LinkLayout>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
